import { SVGProps } from 'react';

const FileOutput = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 2v4a2 2 0 0 0 2 2h4M4 7V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2l-11.937-.001a2 2 0 0 1-2-1M5 17l-3-3 3-3m-3 3h10"
    />
  </svg>
);
export default FileOutput;
